import { useState, useCallback } from 'react';
import { useLazyGetEntitySchemaQuery } from '../rtk/api/datagroupsApi';

export function useSchemaData({ auth, groupName, releaseVersion }) {
  const [schemaData, setSchemaData] = useState(null);
  const [schemaLoading, setSchemaLoading] = useState(false);
  const [schemaError, setSchemaError] = useState(null);
  const [schemaSource, setSchemaSource] = useState(null);

  const [triggerGetEntitySchema] = useLazyGetEntitySchemaQuery();

  const fetchSchema = useCallback(
    async ({ type, name, parent, version }) => {
      if (!groupName || !name || !parent || !version || !releaseVersion || !auth?.user?.id_token)
        return;

      try {
        setSchemaLoading(true);
        setSchemaError(null);

        const { data, error } = await triggerGetEntitySchema(
          {
            groupName,
            type,
            parent,
            name,
            version,
          },
          false
        );

        if (error) throw new Error(error.message || 'Failed to load schema');

        setSchemaData(data);
        setSchemaSource({ type, name, parent });
      } catch (err) {
        setSchemaError(err.message || '');
        setSchemaData(null);
      } finally {
        setSchemaLoading(false);
      }
    },
    [auth?.user?.id_token, groupName, releaseVersion, triggerGetEntitySchema]
  );

  return {
    schemaData,
    schemaLoading,
    schemaError,
    schemaSource,
    fetchSchema,
    setSchemaError,
    setSchemaData,
    setSchemaSource,
  };
}
